/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAvailableUserStatuses$Request {
    accountId: number;
}

export interface GetAvailableUserStatuses$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableUserStatusesRequest = createAction<PayloadData<void, GetAvailableUserStatuses$Request>>('GET_AVAILABLE_USER_STATUSES__GET_AVAILABLE_USER_STATUSES__REQUEST');
export const getAvailableUserStatusesSuccess = createAction<PayloadData<Array<string>, GetAvailableUserStatuses$Request>>('GET_AVAILABLE_USER_STATUSES__GET_AVAILABLE_USER_STATUSES__SUCCESS');
export const getAvailableUserStatusesFailure = createAction<PayloadData<Error, GetAvailableUserStatuses$Request, true>>('GET_AVAILABLE_USER_STATUSES__GET_AVAILABLE_USER_STATUSES__FAILURE');

export const getAvailableUserStatusesActions = [
    getAvailableUserStatusesRequest,
    getAvailableUserStatusesSuccess,
    getAvailableUserStatusesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableUserStatuses = (meta: GetAvailableUserStatuses$Request, config?: GetAvailableUserStatuses$Config) => {
    return {
        CALL_API: {
            types: getAvailableUserStatusesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/available-user-statuses`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

